import {

  CORE_LOAD_ALLAMENITY_REQUEST,
  CORE_LOAD_ALLAMENITY_SUCCESS,

  CORE_LOAD_AMENITYINFO_REQUEST,
  CORE_LOAD_AMENITYINFO_SUCCESS,

} from '../../../types'

const initialState = []
export default {
  amenity: (state = initialState, action) => {
    switch (action.type) {
      case CORE_LOAD_ALLAMENITY_REQUEST:
        return initialState

      case  CORE_LOAD_ALLAMENITY_SUCCESS:
        return action.payload

      default:
        return state
    }
  },
  amenityInfo: (state = initialState, action) => {
    switch (action.type) {
      case CORE_LOAD_AMENITYINFO_REQUEST:
        return initialState

      case  CORE_LOAD_AMENITYINFO_SUCCESS:
        return action.payload

      default:
        return state
    }
  },
}


// WEBPACK FOOTER //
// ./src/features/settings/amenity/reducer.js